import { createAction } from '@reduxjs/toolkit'

import { loginSlice } from '../reducers/login.reducers'

export const {
  setSelectedContextAction,
  setSelectedLocationAction,
  setSelectedSalesGroupAction,
} = loginSlice.actions

export const heapIdentifyUser = createAction<string>('login/heapIdentifyUser')
